import {
  materialRenderers,
  materialCells,
  MaterialAllOfRenderer,
} from "@jsonforms/material-renderers";
import TextFieldTypeRenderer from "../Formfield/TextFieldTypeRenderer";
import TextDescriptionTypeRenderer from "../Formfield/TextDescriptionTypeRenderer";
import IntegerFieldTypeRenderer from "../Formfield/IntegerFieldTypeRenderer";
import DropdownFieldTypeRenderer from "../Formfield/DropdownFieldTypeRenderer";
import DatePickerTypeRenderer from "../Formfield/DatePickerTypeRenderer";
import PropertyTypeRenderer from "../Formfield/PropertyTypeRenderer";
import SubPropertyTypeRenderer from "../Formfield/SubPropertyTypeRenderer";
import CityFieldTypeRenderer from "../Formfield/CityFieldTypeRenderer";
import BankFieldTypeRenderer from "../Formfield/BankFieldTypeRenderer";
import BankBranchesFieldTypeRenderer from "../Formfield/BankBranchesFieldTypeRenderer";
import LocationHubRenderer from "../Formfield/LocationHubRenderer";
import CustomHorizontal from "./CustomHorizontal";
import CustomGroup from "./CustomGroup";
import RadioButtonTypeRenderer from "../Formfield/RadioButtonTypeRenderer";
import ImageUploaderRenderer from "../Formfield/FileUploaderRenderer";
import MultipleSelectRadioButtonTypeRenderer from "../Formfield/MultipleSelectRadioButtonTypeRenderer";
import MultipleSelectWithIconRenderer from "../Formfield/MultipleSelectWithIconRenderer";
import DateTimePickerTypeRenderer from "../Formfield/DateTimePickerTypeRenderer";
import StateFieldTypeRenderer from "../Formfield/StateFieldTypeRenderer";
import PincodeFieldTypeRenderer from "../Formfield/PincodeFieldTypeRenderer";

const CustomBaseRenderers = [
  ...materialRenderers,

  // Layout
  {
    tester: (uischema: any) => (uischema.type === "CustomHorizontal" ? 10 : -1),
    renderer: CustomHorizontal,
  },
  {
    tester: (uischema: any) => (uischema.type === "CustomGroup" ? 10 : -1),
    renderer: CustomGroup,
  },
  // Form Fields
  {
    tester: (uischema: any) =>
      uischema.options?.format === "integerField" ? 10 : -1,
    renderer: IntegerFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "textDescriptionField" ? 10 : -1,
    renderer: TextDescriptionTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "textField" ? 10 : -1,
    renderer: TextFieldTypeRenderer,
  },
  // PincodeFieldTypeRenderer - always available, behaves differently based on flag
  {
    tester: (uischema: any) =>
      uischema.options?.format === "pincodeField" ? 10 : -1,
    renderer: PincodeFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "radioButtonType" ? 10 : -1,
    renderer: RadioButtonTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "multipleSelectRadioButton" ? 10 : -1,
    renderer: MultipleSelectRadioButtonTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "multipleSelectWithIcon" ? 10 : -1,
    renderer: MultipleSelectWithIconRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "datePickerType" ? 10 : -1,
    renderer: DatePickerTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "dateTimePickerType" ? 10 : -1,
    renderer: DateTimePickerTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "dropDownFieldType" ? 10 : -1,
    renderer: DropdownFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "subPropertyType" ? 10 : -1,
    renderer: SubPropertyTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "cityField" ? 10 : -1,
    renderer: CityFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "stateField" ? 10 : -1,
    renderer: StateFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "bankField" ? 10 : -1,
    renderer: BankFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "bankBranchesField" ? 10 : -1,
    renderer: BankBranchesFieldTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "locationHubType" ? 10 : -1,
    renderer: LocationHubRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "propertyType" ? 10 : -1,
    renderer: PropertyTypeRenderer,
  },
  {
    tester: (uischema: any) =>
      uischema.options?.format === "imageUploader" ? 10 : -1,
    renderer: ImageUploaderRenderer,
  },
];

export default CustomBaseRenderers;
